import type { ComponentProps } from 'react';

import { GuardRemoteOption as GuardRemoteOption_ } from '@code-expert/react';
import type { PartialProps } from '@code-expert/type-utils';
import { Loading } from '/imports/ui/components/Loading';

type GuardRemoteOptionProps<A> = PartialProps<
  ComponentProps<typeof GuardRemoteOption_<A>>,
  'pending'
>;

/**
 * Guard a render tree from rendering unless we have a value
 */
export const GuardRemoteOption = <A,>({
  value,
  render,
  pending = () => <Loading />,
  initial = pending,
  alt,
}: GuardRemoteOptionProps<A>) => (
  <GuardRemoteOption_ value={value} initial={initial} pending={pending} render={render} alt={alt} />
);
